<ng-container *ngIf="withCard; else templateContent">
  <mat-card>
    <mat-card-title class="tw-flex tw-justify-center tw-py-2"
      >{{ cardTitle }}
    </mat-card-title>
    <mat-card-content>
      <ng-container [ngTemplateOutlet]="templateContent"></ng-container>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #templateContent>
  <!--  FORM-->
  <div class="filtros-horizontal" *ngIf="showFilter">
    <form [formGroup]="form" class="filtro-form">
      <mat-form-field appearance="outline" class="filtro-campo">
        <mat-label>Filtrar</mat-label>
        <input matInput formControlName="search" />
      </mat-form-field>
    </form>

    <mat-form-field
      appearance="outline"
      class="filtro-campo"
      *ngIf="dateFilter"
    >
      <mat-label>Filtrar por Fecha</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        (dateChange)="filtrarPorFecha($event.value)"
        placeholder="Selecciona una fecha"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <button *ngIf="showDownloadBtn" mat-icon-button (click)="download()">
      <mat-icon>download</mat-icon>
    </button>
  </div>

  <!--  CONTENT-->
  <ng-container *ngIf="scrollSize; else templateTable" class="tw-mt-5">
    <cdk-virtual-scroll-viewport
      [itemSize]="itemSize"
      [ngStyle]="{
        height: scrollSize + 'px'
      }"
    >
      <ng-container [ngTemplateOutlet]="templateTable"></ng-container>
    </cdk-virtual-scroll-viewport>
  </ng-container>
  <!--  PAGINATOR-->
  <mat-paginator
    [hidden]="!showPagination"
    [pageSizeOptions]="[5, 10, 20, 50, 100, 150, 200, 300, 500]"
    [pageSize]="sizePagination$ | async"
    showFirstLastButtons
    aria-label="Seleccionar cantidad a mostrar"
    size
    class="tw-sticky"
  >
  </mat-paginator>
</ng-template>

<ng-template #templateTable>
  <div class="tw-overflow-auto app-mat-table-overflow-auto">
    <mat-table
      #table
      matSort
      [dataSource]="dataSource$ | async"
      (matSortChange)="onTableSort($event)"
    >
      <ng-content></ng-content>
      <mat-header-row
        class="tw-bg-gray-200 tw-z-10"
        *matHeaderRowDef="columns"
      ></mat-header-row>

      <ng-container *ngIf="showFooter">
        <mat-footer-row
          class="tw-bg-gray-200 tw-z-10"
          *matFooterRowDef="columns; sticky: true"
        >
        </mat-footer-row>
      </ng-container>

      <mat-row
        *matRowDef="let row; columns: columns"
        [class]="row?.__classRow"
        [appTableContextMenuTrigger]="row"
        [menuEnabled]="!!menuOptions?.template"
        >
        <div
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="menu"
          class="context-menu-trigger">
        </div>
      </mat-row>
      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell">No se tiene ningún dato</td>
      </tr>
    </mat-table>
  </div>
</ng-template>

<mat-menu #menu="matMenu">
  <ng-container
    [ngTemplateOutlet]="menuOptions?.template"
  >
  </ng-container>
</mat-menu>

